import { __assign, __awaiter, __generator } from "tslib";
import { isAction } from "./models";
import { GridServiceApi, GridPlatformDataClient, GridPlatformDataClientAlpha } from "./GriddleDataClient";
import { isGridServiceRowEmpty, toGriddleCell, toGriddleColumn, toGriddleRow, toGriddleRowInfo } from "./models/grid-service/ModelMutations";
import { CoordMap } from "./CoordMap";
import { CoordSet } from "./CoordSet";
import { loggingStateServiceKey } from "@smartsheet/logging-state-service";
import { diContainer } from "@smartsheet/cufflink";
var GriddleStateStore = /** @class */ (function () {
    function GriddleStateStore() {
        this.dataClient = new GridPlatformDataClient();
        this.dataClientAlpha = new GridPlatformDataClientAlpha();
        this.loggingStateService = diContainer.get(loggingStateServiceKey.name);
    }
    GriddleStateStore.prototype.sendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isAction(message)) {
                    return [2 /*return*/, this.processAction(message)];
                }
                return [2 /*return*/];
            });
        });
    };
    GriddleStateStore.prototype.processAction = function (action) {
        switch (action.type) {
            // Column Actions
            case 2002 /* GETALL */:
                return this.getAllColumns(action);
            case 2001 /* GETBYID */:
                return this.getColumnsByIds(action);
            case 2000 /* GETORDER */:
                return this.getColumnOrder(action);
            case 2003 /* GETOPTIONSBYID */:
                return this.getColumnOptionsById(action);
            //Grid Actions
            case 1 /* GETINFO */:
                return this.getGridInfo(action);
            // Row Actions
            case 1000 /* GETORDER */:
                return this.getRowOrder(action);
            case 1001 /* GETBYID */:
                return this.getRowsByIds(action);
            case 1002 /* GETSTRUCTURE */:
                return this.getRowStructure(action);
            // Cell Actions
            case 3001 /* GETMAPBYCOORDS */:
                return this.getCellMapByCoords(action);
            default:
                throw new Error("Unsupported message type");
        }
    };
    GriddleStateStore.prototype.getGridInfo = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.gridInfo(message.gridId))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        this.loggingStateService.error("[getGridInfo] Uncaught exception during request", error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getRowOrder = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var range, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.rowRange(message.gridId), {
                                limit: 100
                            })];
                    case 1:
                        range = _a.sent();
                        return [2 /*return*/, range.rows.map(function (row) { return row.id; })];
                    case 2:
                        error_2 = _a.sent();
                        this.loggingStateService.error("[getRowOrder] Uncaught exception during request", error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getRowsByIds = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, getRowsResponse, rowMap_1, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = action.payload;
                        // payload is invalid if - undefined, or empty or first element is not iterable
                        if (!payload || !(Symbol.iterator in Object(payload[0]))) {
                            throw new Error("Invalid payload");
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.rows(action.gridId), {
                                rowIds: payload[0].toString(),
                                anchors: "ATTACHMENT,DISCUSSION"
                            })];
                    case 2:
                        getRowsResponse = _a.sent();
                        rowMap_1 = new Map();
                        getRowsResponse.rows.forEach(function (row) {
                            var griddleRow = toGriddleRow(row);
                            rowMap_1.set(row.id, griddleRow);
                        });
                        return [2 /*return*/, rowMap_1];
                    case 3:
                        error_3 = _a.sent();
                        this.loggingStateService.error("[getRowsByIds] Uncaught exception during request", error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getRowStructure = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var rowInfo, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rowInfo = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.post(GridServiceApi.rowStructure(action.gridId), {
                                sorting: {}
                            }, {
                                limit: 100
                            })];
                    case 2:
                        response = _a.sent();
                        response.rowInfo.forEach(function (currRowInfo, index, arr) {
                            var griddleRowInfo = toGriddleRowInfo(currRowInfo, arr[index + 1]);
                            rowInfo.push(griddleRowInfo);
                        });
                        return [2 /*return*/, rowInfo];
                    case 3:
                        error_4 = _a.sent();
                        this.loggingStateService.error("[getRowStructure] Uncaught exception during request", error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // TODO: Update once Grid Service implements the actual GET column API
    GriddleStateStore.prototype.getColumnsByIds = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, colMap, response_1, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = action.payload;
                        // payload is invalid if - undefined, or empty or first element is not iterable
                        if (!payload || !(Symbol.iterator in Object(payload[0]))) {
                            throw new Error("Invalid payload");
                        }
                        colMap = new Map();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.columns(action.gridId))];
                    case 2:
                        response_1 = _a.sent();
                        payload[0].forEach(function (id) {
                            var col = response_1.columns.find(function (col) { return col.id === id; });
                            if (col) {
                                colMap.set(id, toGriddleColumn(col));
                            }
                        });
                        return [2 /*return*/, colMap];
                    case 3:
                        error_5 = _a.sent();
                        this.loggingStateService.error("[getColumnsByIds] Uncaught exception during request", error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getAllColumns = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var colMap, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        colMap = new Map();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.columns(action.gridId))];
                    case 2:
                        response = _a.sent();
                        // assume order until the API gives us columns in a separate endpoint
                        response.columns.forEach(function (col) {
                            var column = toGriddleColumn(col);
                            colMap.set(col.id, column);
                        });
                        return [2 /*return*/, colMap];
                    case 3:
                        error_6 = _a.sent();
                        this.loggingStateService.error("[getAllColumns] Uncaught exception during request", error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getColumnOrder = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var colOrder, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        colOrder = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.columns(action.gridId))];
                    case 2:
                        response = _a.sent();
                        response.columns
                            .sort(function (a, b) { return a.index - b.index; })
                            .forEach(function (col) {
                            colOrder.push(col.id);
                        });
                        return [2 /*return*/, colOrder];
                    case 3:
                        error_7 = _a.sent();
                        this.loggingStateService.error("[getColumnOrder] Uncaught exception during request", error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getColumnOptionsById = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, ids, offsets, colOptMap, shouldFetchMore_1, attempts, columnOptionsRequests, columnOptsResponses, error_8;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = action.payload;
                        // payload is invalid if - undefined, or empty or first element is not iterable
                        if (!payload || !(Symbol.iterator in Object(payload[0]))) {
                            throw new Error("Invalid payload");
                        }
                        ids = payload[0].slice();
                        offsets = new Map();
                        ids.forEach(function (id) {
                            offsets.set(id, 1);
                        });
                        colOptMap = new Map();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        shouldFetchMore_1 = true;
                        attempts = 0;
                        _a.label = 2;
                    case 2:
                        if (!(shouldFetchMore_1 && attempts < 1000)) return [3 /*break*/, 4];
                        columnOptionsRequests = ids.map(function (columnId) {
                            return new Promise(function (resolve, reject) {
                                void _this.dataClient
                                    .get(GridServiceApi.columnOptions(action.gridId, columnId, offsets.get(columnId)))["catch"](function (error) { return reject(error); })
                                    .then(function (response) {
                                    if (response) {
                                        resolve(__assign(__assign({}, response), { columnId: columnId }));
                                    }
                                });
                            });
                        });
                        return [4 /*yield*/, Promise.all(columnOptionsRequests)];
                    case 3:
                        columnOptsResponses = _a.sent();
                        shouldFetchMore_1 = false;
                        columnOptsResponses.forEach(function (response) {
                            var columnOptions = response.columnOptions, columnId = response.columnId, pagination = response.pagination;
                            var currentColOpts = colOptMap.get(columnId);
                            if (currentColOpts) {
                                colOptMap.set(columnId, currentColOpts.concat(columnOptions));
                            }
                            else {
                                colOptMap.set(columnId, columnOptions);
                            }
                            if (pagination.total < pagination.limit) {
                                var idxToRemove = ids.findIndex(function (id) { return id === columnId; });
                                ids.splice(idxToRemove, 1);
                                return;
                            }
                            shouldFetchMore_1 = true;
                            var currentOffset = offsets.get(columnId) || 1;
                            offsets.set(columnId, pagination.total + currentOffset);
                        });
                        attempts += 1;
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, colOptMap];
                    case 5:
                        error_8 = _a.sent();
                        this.loggingStateService.error("[getColumnOptionsById] Uncaught exception during request", error_8);
                        throw error_8;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GriddleStateStore.prototype.getCellMapByCoords = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var range, resultCoordMap, payload, coords, coordSet, _i, coords_1, coord, columnMap_1, response, rowMap, emptyRowMap, _a, _b, row, isRowEmpty, _c, _d, cell, column, griddleCell, _e, _f, coord, row, column, griddleCell, griddleCell, error_9;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.rowRange(action.gridId), { limit: 100 })];
                    case 1:
                        range = _g.sent();
                        resultCoordMap = new CoordMap();
                        payload = action.payload;
                        // payload is invalid if - undefined, or empty or first element is not iterable
                        if (!payload || !(Symbol.iterator in Object(payload[0]))) {
                            throw new Error("Invalid payload");
                        }
                        coords = payload[0];
                        coordSet = new CoordSet();
                        for (_i = 0, coords_1 = coords; _i < coords_1.length; _i++) {
                            coord = coords_1[_i];
                            coordSet.add(coord);
                        }
                        columnMap_1 = new Map();
                        return [4 /*yield*/, this.dataClient.get(GridServiceApi.columns(action.gridId))];
                    case 2:
                        response = _g.sent();
                        // assume order until the API gives us columns in a separate endpoint
                        response.columns.forEach(function (col) {
                            columnMap_1.set(col.id, col);
                        });
                        rowMap = new Map();
                        emptyRowMap = new Map();
                        for (_a = 0, _b = range.rows; _a < _b.length; _a++) {
                            row = _b[_a];
                            rowMap.set(row.id, row);
                            isRowEmpty = isGridServiceRowEmpty(row);
                            emptyRowMap.set(row.id, isRowEmpty);
                            if (row.cells) {
                                for (_c = 0, _d = row.cells; _c < _d.length; _c++) {
                                    cell = _d[_c];
                                    if (coordSet.has({ rowId: cell.rowId, columnId: cell.columnId })) {
                                        column = columnMap_1.get(cell.columnId);
                                        if (column) {
                                            griddleCell = toGriddleCell(row, column, cell, isRowEmpty);
                                            resultCoordMap.set(griddleCell.coord, griddleCell);
                                            coordSet["delete"](griddleCell.coord);
                                        }
                                    }
                                }
                            }
                        }
                        // check for coords that did not have cells returned
                        for (_e = 0, _f = coordSet.values(); _e < _f.length; _e++) {
                            coord = _f[_e];
                            if (rowMap.has(coord.rowId)) {
                                row = rowMap.get(coord.rowId);
                                column = columnMap_1.get(coord.columnId);
                                if (column) {
                                    if (!emptyRowMap.get(row.id) &&
                                        column &&
                                        (column.defaultType === "CHECKBOX" || column.defaultType === "STAR" || column.defaultType === "FLAG")) {
                                        griddleCell = toGriddleCell(row, column);
                                        resultCoordMap.set(griddleCell.coord, griddleCell);
                                    }
                                    else if (row.format.format1 !== 0 || row.format.format2 !== 0 || row.conditionalFormat) {
                                        griddleCell = toGriddleCell(row, column, undefined, emptyRowMap.get(row.id));
                                        resultCoordMap.set(griddleCell.coord, griddleCell);
                                    }
                                }
                            }
                        }
                        return [2 /*return*/, resultCoordMap];
                    case 3:
                        error_9 = _g.sent();
                        this.loggingStateService.error("[getCellMapByCoords] Uncaught exception during request", error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GriddleStateStore;
}());
export { GriddleStateStore };
//# sourceMappingURL=GriddleStateStore.js.map